import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    let isTab =
      /\/partneri\/[0-9]+\/.+/.test(pathname) ||
      /\/(roba|usluge|javne-usluge)\/[0-9]+\/[0-9]+\/.+/.test(pathname);
    if (!isTab) {
      window.scrollTo(0, 0);
    }
  }, [pathname]);

  return null;
}

export default ScrollToTop;
